import * as THREE from "../../../libs/three.js/build/three.module.js";
import {Utils} from "../../utils.js";  
 

class Label  extends THREE.EventDispatcher{
    constructor(o={}){
        super()
        
        this.position = o.pos;
        this.text = o.text || '';
        this.elem = $('<div class="hide"><a></a></div>');
        o.className && this.elem.addClass(o.className)
        this.elem.find('a').html(this.text); 
        $("#potree_labels").append(this.elem)
        this.pos2d = new THREE.Vector3
        this.dom = o.dom || viewer.renderArea
        this.camera = o.camera || viewer.scene.getActiveCamera() 
        
        
        let update = (e)=>{
            this.update(e) 
        }
        viewer.addEventListener('camera_changed',  update)
           
         
        this.addEventListener('dispose', ()=>{
            viewer.removeEventListener('camera_changed',  update)
            this.dispose()
            
        })
        
    }
     
    update(){
        if(!this.position || this.elem.hasClass('unvisible'))return
        var p = Utils.getPos2d(this.position, viewer.mainViewport,this.dom);
        if(!p.trueSide){
            this.elem.addClass("hide");  return;
        }
        this.elem.css({
            left: p.pos.x +'px',
            top: p.pos.y +'px'
        })
        
        
        
        this.elem.removeClass("hide");
        this.pos2d = p.vector;
        
        
        
        
        
    }
    
    setVisible(visi){
        if(!visi){
            this.elem.addClass("unvisible");  
        }else{
            this.elem.removeClass("unvisible");
            this.update()
        }
    }
    
    setText(text){
        this.text = text || '';
        this.elem.find('a').html(this.text); 
    }
    setPos(pos){
        this.position = pos;
    }
    
    dispose(){
        this.elem.remove();
        this.removeAllListeners()
    }
     
     
}

export default Label;


